import {
  getCustomActivities,
  setCustomActivities,
} from '../api/customactivities.js';



export async function GetAllCustomActivities(id, enableOnly=false) {
  const  activities = await getCustomActivities(id);

  if (activities?.length > 0) {
    
    return activities.map((a) => {
      a.color = a.cae_data?.display?.color;
      a.domain_color = a.dac_data?.display?.color;
      return a;
    }).filter(a => ((a.cae_is_enable && enableOnly) || !enableOnly));
  }
  return [];
}

export async function ImportCustomActivities(id, rows ){
  try {
    return await setCustomActivities(id, rows);
  } catch (e) {
    console.log(e);
    return { error: e.error };
  }
}